import * as Yup from 'yup'

const CmsMerchantCreateFormSchema = Yup.object().shape({
  merchant_id: Yup.number()
    .required('Required'),
  bio: Yup.string()
    .required('Required')
})

export default CmsMerchantCreateFormSchema
